/**
 * product-accordions.js
 * Pairs with sections/product-accordions.liquid.
 *
 * Keeps at most one [data-accordion] <details> open at a time. Implemented
 * as a plain 'toggle' listener (not the HTML <details name="..."> grouping
 * attribute) since that attribute is unsupported on older browsers and
 * degrades silently there (multiple rows could stay open with no visible
 * error).
 */
(function () {
  var accordions = document.querySelectorAll('[data-accordion]');

  accordions.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      accordions.forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });
})();
